<template>
  <custom-dialog class="topic-sel-model-dialog" width="1200px" :title="model.title" :visible="visible" v-on="$listeners" :append-to-body="true">
    <div class="dialog-body">
      <div class="search-bd">
        <el-form :inline="true" @submit.native.prevent>
          <el-form-item style="float: right">
            <search-input :placeholder="$t('dms_topic_sel_model_dialog.wmxmcwmxdm')" v-model="formSearch.search" @fetch="getTableList('init')"></search-input>
          </el-form-item>
          <el-form-item style="float: right">
            <el-radio-group v-model="formSearch.tslClass" @change="tslClassChange">
              <el-radio-button v-for="(item, index) in propertyMap.iot_tsl_class_type" :key="index" :label="item.value">{{ item.name }}</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item style="float: right">
            <switch-button :link="$refs.container"></switch-button>
          </el-form-item>
        </el-form>
      </div>
      <switch-container ref="container" @search="getTableList" @clear="clearFilter()">
        <el-form :inline="true" label-position="top">
          <el-form-item :label="$t('dms_topic_sel_model_dialog.lei_xing')">
            <el-select clearable v-model="formSearch.tslType">
              <el-option v-for="(item, i) in tslTypeList" :key="i" :label="item.name" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('dms_topic_sel_model_dialog.bu_jian')">
            <el-input v-model="formSearch.component" :placeholder="$t('dms_topic_sel_model_dialog.bu_jian')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('dms_topic_sel_model_dialog.fen_lei')">
            <el-input v-model="formSearch.dataGroup" :placeholder="$t('dms_topic_sel_model_dialog.fen_lei')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('dms_topic_sel_model_dialog.TCPdai_ma')">
            <el-input v-model="formSearch.tcpDataCode" :placeholder="$t('dms_topic_sel_model_dialog.TCPdai_ma')"></el-input>
          </el-form-item>
        </el-form>
      </switch-container>
      <custom-table
        height="400px"
        :data="tableList"
        :column="tableColumn"
        @filter="filterChange"
        @sort="sortChange"
        v-model="selectData"
        type="checkbox"
        :clickSelection="true"
        :slots="['showUnit', 'needTestTypes']"
      >
        <template v-slot:showUnit="scope">
          {{ getShowUnit(scope.row) }}
        </template>
        <template v-slot:needTestTypes="scope">
          {{ getNeedTestTypes(scope.row.needTestTypes) || '-' }}
        </template>
      </custom-table>
      <div class="table-page">
        <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">{{ $t('Common.com_cancel') }}</el-button>
      <el-button type="primary" @click="onSave">{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis.js';
import dialogMixins from '@/mixins/dialog_mixins';
import resetFormSearchMixins from '@/mixins/reset_form_search_mixins';
import mixins from './mixins';

export default {
  name: 'topicSelModelDialog',
  mixins: [dialogMixins, resetFormSearchMixins, mixins],
  components: {},
  props: {
    protocolCode: String,
    topicId: String,
  },
  data() {
    return {
      tableCode: 'protocol_topic_sel_model',
      formSearch: {
        search: '',
        pageSize: 30,
        pageNum: 1,
        tslClass: '',
        component: '',
        dataGroup: '',
        tslType: '',
        tcpDataCode: '',
      },
      tableList: [],
      totalRows: null,
      selectData: [],
      tslTypeList: [],
    };
  },
  mounted() {
    this.getTableColumn();
    this.getVersionList();
  },
  methods: {
    tslClassChange() {
      this.formSearch.tslType = '';
      this.propertyMap.iot_tsl_class_type.forEach((item) => {
        if (this.formSearch.tslClass === item.value) {
          this.tslTypeList = item.children || [];
        }
      });
      this.onPageChange({ page: 1 });
    },
    // 初始化版本下拉
    getVersionList: function () {
      this.getDictionary('iot_tsl_class_type', (data) => {
        this.formSearch.tslClass = data.iot_tsl_class_type[0].value;
        this.tslTypeList = this.propertyMap.iot_tsl_class_type[0].children || [];
        this.recordFilter();
        this.onPageChange({ page: 1 });
      });
    },
    getTableList() {
      this.$getJSON(apis.TslTopicUnAssociatePage, this.getReqData()).then((res) => {
        const list = res.data.list;
        this.tableList = list;
        this.totalRows = res.data.total;
      });
    },
    getReqData() {
      return {
        ...this.formSearch,
        protocolCode: this.protocolCode,
        topicId: this.topicId,
      };
    },
    onSave() {
      this.$emit('confirm', this.selectData.slice());
      this.visible = false;
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
  },
};
</script>

<style lang="scss">
.topic-sel-model-dialog {
  .search-bd {
    overflow: hidden;
  }
  .el-radio-group {
    float: left;
  }
}
</style>
